import React, { useState } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import WordmarkIcon from 'images/icons/logos/wordmark.svg?react-svg';
import Cart from './Cart';
import CheckoutForm from './form';
import QuickView from '../quickView';
import { addCart } from '../cart/actions';
import Banner from 'components/banner';
import styles from './styles.mod.scss';

function CheckoutPage({ addCart }) {
  const [quickViewProduct, setQuickViewProduct] = useState(null);
  const [hasBanner, setHasBanner] = useState(false);

  function addToCart(product, qty) {
    return addCart(product, qty, { checkout: true });
  }

  function handleBannerMessage(message) {
    if (!!message && !hasBanner) setHasBanner(true);
    if (!message && hasBanner) setHasBanner(false);
  }

  return (
    <div className={styles.background}>
      <div
        className={classnames(styles.container, {
          [styles.bannerPadding]: hasBanner
        })}
      >
        <div className={styles.logoContainer}>
          <a href="/" className={styles.logo}>
            <WordmarkIcon />
          </a>
        </div>

        <Banner
          checkout
          onMessageChange={handleBannerMessage}
          className={styles.siteBanner}
        />

        <Cart openQuickView={setQuickViewProduct} hasBanner={hasBanner} />

        <CheckoutForm openQuickView={setQuickViewProduct} />

        <QuickView
          product={quickViewProduct}
          changeProduct={setQuickViewProduct}
          addToCart={addToCart}
          close={() => setQuickViewProduct(null)}
        />
      </div>
    </div>
  );
}

const ConnectedCheckoutPage = connect(
  () => ({}),
  { addCart }
)(CheckoutPage);

export default ConnectedCheckoutPage;
